// src/components/BandeauGardeEcriture.jsx — ⚖ CHEMIN ARGENT (affichage seul).
//
// ══ CE BANDEAU A DEUX SOURCES, ET IL N'EN LISAIT QU'UNE ═════════════════════
//
// `saveData` (src/App.jsx) route depuis le 2026-09-08 le message du SERVEUR
// vers `gardeAlert` — conflit de version 409, garde volumétrique serveur, et
// désormais « je n'ai pas pu lire la réponse ». Mais le JSX était du TEXTE
// FIGÉ : `gardeAlert.message` n'a jamais été lu. Ce que Dimitri lisait en
// corrigeant un montant de facturation quand la réponse était une page de
// protection servie en 200 :
//
//   « Écriture refusée par la garde de sécurité. Une tentative d'écriture
//     aurait supprimé une grosse partie des données (undefined résas →
//     undefined, undefined mois → undefined). AUCUNE DONNÉE MODIFIÉE. »
//
// Trois fautes dans une bulle : du jargon interne, des `undefined`, et surtout
// une affirmation que PERSONNE ne peut faire — il repartait convaincu que rien
// n'était parti, sur l'argent.
//
// ══ LA RÈGLE ════════════════════════════════════════════════════════════════
//
// La garde volumétrique LOCALE est la seule qui SAIT qu'elle n'a rien écrit :
// elle a refusé avant le réseau. Elle garde donc son texte chiffré et son
// « Aucune donnée modifiée ». On la reconnaît à `prevResas`, que ses trois
// variantes portent (cf. `src/lib/save-data-guards.js`) et que rien d'autre
// ne pose.
//
// TOUT LE RESTE affiche le message TEL QU'IL A ÉTÉ ÉCRIT, sans titre ajouté :
// ces messages sont rédigés pour se suffire (« … je ne sais pas si
// l'enregistrement est passé. Ne réessaie pas à l'aveugle — recharge la page
// pour voir ce qui est vraiment enregistré. »), et un titre inventé par
// l'affichage rementirait à leur place.
//
// Extrait d'App.jsx pour être MONTABLE : le défaut fermé ici est précisément
// « le verdict est juste et meurt avant l'écran » — il ne se prouve qu'en
// lisant le texte rendu, pas en inspectant un état.

import { DS } from "../lib/ui";

export default function BandeauGardeEcriture({ alerte, onFermer }) {
  if (!alerte) return null;

  // `prevResas` posé ⇒ garde volumétrique locale : rien n'est parti, on peut
  // le dire. Sinon : on ne sait pas, et le message le dit lui-même.
  const gardeLocale = alerte.prevResas !== undefined;

  return (
    <div
      role="alert"
      data-testid="app-garde-ecriture"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background: "#fff8e6",
        borderBottom: `2px solid ${DS.amber}`,
        padding: "12px 18px",
        display: "flex",
        alignItems: "center",
        gap: 14,
        fontFamily: DS.fontBody,
        boxShadow: "0 2px 8px rgba(0,0,0,.08)",
      }}
    >
      <span style={{ fontSize: 20 }} aria-hidden="true">
        ⚠️
      </span>
      <div style={{ flex: 1, fontSize: 13, color: DS.navy, lineHeight: 1.4 }}>
        {gardeLocale ? (
          <>
            <div style={{ fontWeight: 700, marginBottom: 2 }}>
              Écriture refusée par la garde de sécurité.
            </div>
            <div style={{ color: "#555", fontSize: 12 }}>
              {/* Les mois ne sont chiffrés que par la garde GLOBALE — les deux
                  autres (per-mois, sommes) n'ont jamais porté ces champs et
                  affichaient « undefined mois → undefined » depuis toujours. */}
              Une tentative d'écriture aurait supprimé une grosse partie des
              données ({alerte.prevResas} résas → {alerte.newResas}
              {alerte.prevMonths !== undefined
                ? `, ${alerte.prevMonths} mois → ${alerte.newMonths}`
                : ""}
              ). Aucune donnée modifiée. Recharge la page si tu n'as rien fait —
              sinon contacte le support.
            </div>
          </>
        ) : (
          <div style={{ fontSize: 13, color: DS.navy }}>{alerte.message}</div>
        )}
      </div>
      <button
        type="button"
        onClick={onFermer}
        aria-label="Fermer"
        style={{
          background: "transparent",
          border: "none",
          fontSize: 18,
          color: DS.navy,
          cursor: "pointer",
          padding: "4px 8px",
          fontWeight: 700,
        }}
      >
        ×
      </button>
    </div>
  );
}
